import React, { MouseEvent, ReactNode } from 'react';
import { Element } from './AccordionItem.styles';

export interface AccordionItemProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const AccordionItem = React.forwardRef<HTMLDivElement, AccordionItemProps>(function AccordionItem(
  { children, ...props },
  ref
) {
  return <Element ref={ref}>{children}</Element>;
});

export default AccordionItem;
